/**
 * @generated SignedSource<<2f0f1b9d075ba8c1a7abeaae039dc2eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includedTournaments",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rankingType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "category",
    "variableName": "category"
  }
],
v10 = [
  (v2/*: any*/),
  (v6/*: any*/),
  (v4/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPoints",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tournamentId",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "start_date"
  },
  {
    "kind": "Literal",
    "name": "sortDirection",
    "value": "asc"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Tournament",
  "kind": "LinkedField",
  "name": "availableTournaments",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganisationRankingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Ranking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "organisation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": (v9/*: any*/),
            "kind": "FragmentSpread",
            "name": "RankingTable_ranking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RankingTournaments_ranking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamplayRankingTable_ranking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrganisationRankingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Ranking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "organisation",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rankingTournamentsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "RankingPlayer",
            "kind": "LinkedField",
            "name": "rankingPlayers",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Player",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nationality",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryPosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousCategoryPosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousPosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roundsPlayed",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RankingPlayerRound",
                "kind": "LinkedField",
                "name": "rankingPlayerRounds",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isIncluded",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v13/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useOnlyCategories",
            "storageKey": null
          },
          {
            "alias": "sortedTournaments",
            "args": (v15/*: any*/),
            "concreteType": "RankingTournament",
            "kind": "LinkedField",
            "name": "rankingTournaments",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": "rankingTournaments(sortBy:\"start_date\",sortDirection:\"asc\")"
          },
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "RankingTournament",
            "kind": "LinkedField",
            "name": "rankingTournaments",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mandatory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "percentage",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rewardedPlacements",
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Ranking",
                "kind": "LinkedField",
                "name": "ranking",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v18/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tournament",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v17/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "rankingTournaments(sortBy:\"start_date\",sortDirection:\"asc\")"
          },
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasActiveTournament",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RankedTeamplay",
            "kind": "LinkedField",
            "name": "rankedTeamplays",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gameDiff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gamesLost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gamesWon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchDiff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchesLost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchesWon",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "played",
                "storageKey": null
              },
              (v16/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "won",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87598f60645ae7ca1878ffbd5800a64c",
    "id": null,
    "metadata": {},
    "name": "OrganisationRankingQuery",
    "operationKind": "query",
    "text": "query OrganisationRankingQuery(\n  $category: String\n  $id: ID!\n) {\n  ranking(id: $id) {\n    databaseId\n    endDate\n    id\n    includedTournaments\n    name\n    rankingType\n    startDate\n    organisation {\n      databaseId\n      name\n      id\n    }\n    ...RankingTable_ranking_15BdcN\n    ...RankingTournaments_ranking\n    ...TeamplayRankingTable_ranking\n  }\n}\n\nfragment NewRankingTournament_ranking on Ranking {\n  ...RankingTournamentModal_ranking\n}\n\nfragment RankingTableEntry_ranking on Ranking {\n  useOnlyCategories\n  sortedTournaments: rankingTournaments(sortBy: \"start_date\", sortDirection: \"asc\") {\n    id\n    tournamentId\n  }\n}\n\nfragment RankingTableEntry_rankingPlayer on RankingPlayer {\n  category\n  categoryPoints\n  categoryPosition\n  position\n  previousCategoryPosition\n  previousPosition\n  roundsPlayed\n  score\n  player {\n    firstName\n    lastName\n    nationality\n    id\n  }\n  rankingPlayerRounds {\n    categoryPoints\n    isIncluded\n    tournamentId\n    score\n    id\n  }\n}\n\nfragment RankingTable_ranking_15BdcN on Ranking {\n  rankingTournamentsCount\n  rankingPlayers(category: $category) {\n    position\n    player {\n      databaseId\n      name\n      id\n    }\n    ...RankingTableEntry_rankingPlayer\n    id\n  }\n  ...RankingTableEntry_ranking\n  id\n}\n\nfragment RankingTournamentFragment_rankingTournament on RankingTournament {\n  id\n  mandatory\n  percentage\n  points\n  rewardedPlacements\n  status\n  ranking {\n    ...RankingTournamentModal_ranking\n    id\n  }\n  tournament {\n    databaseId\n    name\n    startDate\n    status\n    id\n  }\n}\n\nfragment RankingTournamentList_ranking_1nSl80 on Ranking {\n  rankingTournaments(sortBy: \"start_date\", sortDirection: \"asc\") {\n    id\n    ...RankingTournamentFragment_rankingTournament\n  }\n  ...NewRankingTournament_ranking\n  id\n}\n\nfragment RankingTournamentModal_ranking on Ranking {\n  databaseId\n  rankingType\n  availableTournaments {\n    databaseId\n    name\n    id\n  }\n}\n\nfragment RankingTournaments_ranking on Ranking {\n  ...RankingTournamentList_ranking_1nSl80\n}\n\nfragment TeamplayRankingTable_ranking on Ranking {\n  hasActiveTournament\n  rankedTeamplays {\n    gameDiff\n    gamesLost\n    gamesWon\n    lost\n    matchDiff\n    matchesLost\n    matchesWon\n    name\n    played\n    points\n    position\n    tied\n    won\n  }\n}\n"
  }
};
})();

node.hash = "0af802dc353cc8529cf2b1023e2c2165";

module.exports = node;
